import { DocumentNode, gql } from '@apollo/client'

export const GET_DAYCARE_GROUP_URLS: DocumentNode = gql`
    query GetDaycareGroupUrls($groupId: Int!) {
        getDaycareGroupUrls(groupId: $groupId) {
            id
            text
            url
            icon
            daycareGroupId
            daycareIds
        }
    }
`

export const GET_DAYCARE_GROUP_URLS_FOR_DAYCARE: DocumentNode = gql`
    query GetDaycareGroupUrlsForDaycare($daycareId: Int) {
        getDaycareGroupUrlsForDaycare(daycareId: $daycareId) {
            id
            text
            url
            icon
            daycareGroupId
        }
    }
`

export const ADD_DAYCARE_GROUP_URL: DocumentNode = gql`
    mutation AddDaycareGroupUrl(
        $groupId: Int!
        $text: String!
        $url: String!
        $icon: DaycareGroupUrlTypes!
        $daycareIds: [Int]!
    ) {
        addDaycareGroupUrl(groupId: $groupId, text: $text, url: $url, icon: $icon, daycareIds: $daycareIds)
    }
`

export const UPDATE_DAYCARE_GROUP_URL: DocumentNode = gql`
    mutation updateDaycareGroupUrl(
        $groupId: Int!
        $urlId: Int!
        $text: String!
        $url: String!
        $icon: DaycareGroupUrlTypes!
        $daycareIds: [Int]!
    ) {
        updateDaycareGroupUrl(
            groupId: $groupId
            urlId: $urlId
            text: $text
            url: $url
            icon: $icon
            daycareIds: $daycareIds
        )
    }
`

export const DELETE_DAYCARE_GROUP_URL: DocumentNode = gql`
    mutation DeleteDaycareGroupUrl($groupId: Int!, $urlId: Int!) {
        deleteDaycareGroupUrl(groupId: $groupId, urlId: $urlId)
    }
`

export const SET_DAYCARE_GROUP_PSU: DocumentNode = gql`
    mutation SetDaycareGroupPSU($groupId: Int!, $daycarePSU: Float!) {
        setDaycareGroupPSU(groupId: $groupId, daycarePSU: $daycarePSU)
    }
`
